import { ExclusivityDetailsModal } from "@faire/retailer-visitor-shared/features/Exclusivity/DetailsModal/ExclusivityDetailsModal";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Button } from "@faire/web--source/slate/Button";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { trackZipCodeProtectionRetailerExclusivityPostCommitmentInfoClick as trackPostCommitmentInfoClick } from "@faire/web-api--source/events/zipCodeProtection/click/retailerExclusivityPostCommitmentInfo";
import { trackZipCodeProtectionRetailerExclusivityPostCommitmentInfoView as trackPostCommitmentInfoView } from "@faire/web-api--source/events/zipCodeProtection/view/retailerExclusivityPostCommitmentInfo";
import { QueryParameters as BrandQueryParams } from "@faire/web-api--source/routes/www/brand/brandToken";
import { QueryParameters as CheckoutQueryParams } from "@faire/web-api--source/routes/www/checkout/success/orderToken";
import { QueryParameters as MyBrandsQueryParams } from "@faire/web-api--source/routes/www/my-brands";
import { QueryParameters as ProductQueryParams } from "@faire/web-api--source/routes/www/product/productToken";
import qs from "query-string";
import React, { ComponentProps, PropsWithChildren, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

interface IProps {
  origin: ComponentProps<typeof ExclusivityDetailsModal>["origin"];
  agreementToken: string | undefined;
  brandToken: string | undefined;
  color: string;
}

export const ExclusivityDetailsLink: React.FC<PropsWithChildren<IProps>> = ({
  agreementToken,
  brandToken,
  origin,
  color,
  children,
}) => {
  const { exclusivity_agreement_details } = useQueryParams<{
    exclusivity_agreement_details?: string;
  }>(PARSING_FUNCTIONS[origin]);
  const history = useHistory();
  const location = useLocation();
  const newQueryParams = new URLSearchParams(location.search);

  useEffect(() => {
    trackPostCommitmentInfoView(agreementToken ?? "", origin);
  }, [agreementToken, origin]);

  if (agreementToken) {
    newQueryParams.append("exclusivity_agreement_details", agreementToken);
  }

  const linkTo = {
    pathname: location.pathname,
    search: newQueryParams.toString(),
  };

  const isDetailsModalOpen = exclusivity_agreement_details === agreementToken;
  const handleClose = () => {
    history.push({
      pathname: history.location.pathname,
      search: qs.stringify({
        ...getCurrentPath().searchParams,
        exclusivity_agreement_details: undefined,
      }),
    });
  };

  return (
    <>
      <Button
        variant="tertiary"
        linkTo={linkTo}
        data-test-id="exclusivity-link"
        tertiaryColor={color}
        style={{ display: "inline" }}
        onClick={() =>
          trackPostCommitmentInfoClick(agreementToken ?? "", origin)
        }
      >
        {children}
      </Button>
      {isDetailsModalOpen ? (
        <ExclusivityDetailsModal
          origin={origin}
          agreementToken={exclusivity_agreement_details ?? ""}
          brandToken={brandToken}
          onClose={handleClose}
        />
      ) : null}
    </>
  );
};

const PARSING_FUNCTIONS = {
  brand: BrandQueryParams.parse,
  "my-brands": MyBrandsQueryParams.parse,
  product: ProductQueryParams.parse,
  "post-checkout": CheckoutQueryParams.parse,
  "my-orders": () => ({}),
  "exclusivity-landing-page": () => ({}),
};
